/**
 * SELECT 2 のドロップダウン
 **/

$(document).ready(function () {
  "use strict";

  $.when(init(), selector_init())
    .done(function () {
      onChangeSelect();
      setSelectedFromUrl();
    })
    .fail(function () {
      console.log("select2_error");
    });

  function init() {
    var select_2 = $(".select_2_dropdowns");

    //@todo placeholderが効かない
    select_2.select2({
      language: "ja",
      matcher: customMatcher,
      dropdownAutoWidth: true,
      width: "auto",
    });

    select_2.one("select2:open", function (e) {
      $("input.select2-search__field").prop(
        "placeholder",
        "キーワードで絞り込み"
      );
    });

    function customMatcher(params, data) {
      if ($.trim(params.term) === "") {
        return data;
      }

      if (typeof data.text === "undefined") {
        return null;
      }
      /*
      ZEtoHE 英数字を半角に
      HKtoZK 半角カタカナを全角カタカナに
      HGtoKK ひらがなをカタカナに
      */
      var term = moji(params.term.toUpperCase())
        .convert("ZEtoHE")
        .convert("HKtoZK")
        .convert("HGtoKK")
        .toString();

      var text = moji(data.text.toUpperCase())
        .convert("ZEtoHE")
        .convert("HKtoZK")
        .convert("HGtoKK")
        .toString();

      if (text.indexOf(term) > -1) {
        return data;
      }

      var searchText = $(data.element).data("search");
      if (searchText) {
        searchText = moji(searchText.toUpperCase())
          .convert("ZEtoHE")
          .convert("HKtoZK")
          .convert("HGtoKK")
          .toString();
        if (searchText.indexOf(term) > -1) {
          return data;
        }
      }
      return null;
    }
  }

  // 複数パラメータに対応
  function setSelectedFromUrl() {
    var urlParams = new URLSearchParams(window.location.search);

    $(".select_2_dropdowns").each(function () {
      var selectElement = $(this);
      var selectedValues = [];

      for (const [key, value] of urlParams) {
        if (selectElement.data("section") === key) {
          selectedValues.push(value);
        }
      }

      if (selectElement.hasClass("select_2_multi")) {
        selectElement.off("change", onChangeSelectHandler);
        selectElement.val(selectedValues).trigger("change.select2");
        selectElement.on("change", onChangeSelectHandler);
      }
    });
  }

  function selector_init() {
    var select_2_val = $(".select_2_dropdowns").find("option");

    select_2_val.each(function () {
      var option = $(this);
      var this_val = option.data("url");
      if (typeof this_val === "undefined") {
        return false;
      }

      var location_val = location.search.toString().toLowerCase();
      var substr_val = this_val
        .substr(this_val.indexOf("?"))
        .toString()
        .toLowerCase();

      if (substr_val == location_val) {
        let index = parseInt(option.val());
        option.closest("select").val(index).trigger("change");
      }
      //console.log(option.index()+'/// val :'+ substr_val + '\n loc :' + location_val);
    });
  }

  function onChangeSelect() {
    $(".select_2_dropdowns").on("change", onChangeSelectHandler);
  }

  function onChangeSelectHandler() {
    var url = $(this).find("option:selected").data("url");
    if (typeof url !== "undefined") {
      window.location.href = url;
    }
  }
});
